import { useEffect, useState } from 'react';
import { supportApi } from '../api/Supportapi';
import TicketDetail from './TicketDetail';

const STATUS_STYLES = {
  new: 'bg-blue-50 text-blue-600',
  assigned: 'bg-amber-50 text-amber-600',
  in_progress: 'bg-purple-50 text-purple-600',
  resolved: 'bg-emerald-50 text-emerald-600',
  closed: 'bg-gray-100 text-gray-500',
};

const STATUS_LABELS = {
  new: 'New',
  assigned: 'Assigned',
  in_progress: 'In Progress',
  resolved: 'Resolved',
  closed: 'Closed',
};

export default function MyTickets({ refreshKey }) {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    supportApi
      .listTickets()
      .then((data) => {
        if (!cancelled) setTickets(data.data || []);
      })
      .catch((err) => !cancelled && setError(err.message))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [refreshKey]);

  if (selectedId) {
    return <TicketDetail ticketId={selectedId} onBack={() => setSelectedId(null)} />;
  }

  return (
    <div>
      <h2 className="text-lg font-bold bg-gradient-to-r from-purple-700 to-pink-600 bg-clip-text text-transparent mb-4">My Support Tickets</h2>

      {loading && <p className="text-sm text-gray-400 py-6 text-center">Loading tickets...</p>}
      {error && <div className="bg-red-50 text-red-600 text-sm rounded-xl p-3 mb-4 border border-red-100">{error}</div>}
      {!loading && !error && tickets.length === 0 && (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center text-sm text-gray-400">You haven't raised any support tickets yet.</div>
      )}

      <div className="flex flex-col gap-2.5">
        {tickets.map((t) => (
          <button
            key={t.id}
            onClick={() => setSelectedId(t.id)}
            className="w-full text-left bg-white border border-gray-100 rounded-2xl shadow-sm hover:shadow-md hover:border-purple-200 p-4 transition-all"
          >
            <div className="flex items-center justify-between gap-3 mb-1.5">
              <span className="text-[10px] font-semibold text-purple-600 uppercase">{t.ticket_number}</span>
              <span className={`text-[10px] font-semibold px-2.5 py-0.5 rounded-full shrink-0 whitespace-nowrap ${STATUS_STYLES[t.status] || 'bg-gray-50 text-gray-500'}`}>
                {STATUS_LABELS[t.status]}
              </span>
            </div>
            <p className="text-sm font-bold text-[#0D1B3D] mb-0.5">{t.subject}</p>
            <p className="text-xs text-gray-400">{t.category} · {new Date(t.created_at).toLocaleDateString()}</p>
          </button>
        ))}
      </div>
    </div>
  );
}